<template lang="pug">
  .modal.is-active(:class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
    .modal-background
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalSeleccionarDocumentosFirmar"
      )
        seleccionar-documentos-firmar(
          :idEmpleado="+codigoEmpleadoInterno"
          @close="closeModalSeleccionarDocumentosFirmar"
        )
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalListaLibrosVacaciones"
      )
        .modal-background
        .box.position-relative
          component-lista-libros-vacaciones(
            :codigoEmpleado="+codigoEmpleadoInterno"
            @close="closeModalListaLibrosVacaciones"
          )

    .modal-card.card.w-942
      .modal-card-head.flex
        div.flex-1
          .title Datos del Empleado
        button.delete(@click="close")
      .card-content.card-content-max
        section
          .title
            | Datos
          .body
            .flex.datos-empleado-container
              .flex-1
                .flex.fd-c-datos
                  .control.flex-1
                    p Codigo
                    input.input(
                      type="text",
                      :disabled="true",
                      v-model="empleado.codigo"
                    )
                  .control.flex-1
                    p Nombre
                    input.input(
                      type="text",
                      v-model="empleado.nombre"
                      :disabled="isLoading"
                    )
                  .control.flex-1
                    p Perfil
                    .select
                      select(v-model='empleado.perfilVacaciones',:disabled="isLoading")
                        option(value="usuario") Usuario
                        option(value="jefe") Jefe
                        option(value="recursos humanos") Recursos Humanos
                    //- input.input(
                      type="text",
                      v-model="empleado.perfilVacaciones"
                    //- )
                .flex.fd-c-datos
                  .control.flex-1
                    p Usuario
                    input.input(
                      type="text",
                      v-model="empleado.usuario"
                      :disabled="isLoading"
                    )
                  .control.flex-1.title-singular
                    p Cargo
                    .input-container
                      input.input(
                        type="text",
                        v-model="empleado.cargo"
                        :disabled="isLoading"
                        readonly
                        @click="mostrarBusquedaCargo = true"
                      )
                      span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaCargo = true")
                        i.fa.fa-search
                      .erase-data(@click="empleado.cargo = ''")
                        .icon
                          .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaCargo"
                        )
                        lookup-cargo(
                          @selected="seleccionarCargo"
                          @close="mostrarBusquedaCargo = false"
                        )
                  .control.flex-1
                    p Email
                    input.input(
                      type="text",
                      v-model="empleado.email"
                      :disabled="isLoading"
                    )
                .flex.position-relative.fd-c-datos
                  .control.flex-1.title-singular
                    p Codigo Jefe
                    .input-container
                      input.input(
                        type="number",
                        v-model="empleado.codigoJefe"
                        :disabled="isLoading"
                      )
                      span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaJefe = true")
                        i.fa.fa-search
                      .erase-data(@click="empleado.codigoJefe = ''")
                        .icon
                          .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaJefe"
                        )
                          lookup-small-empleado(
                            @selected="seleccionarJefe"
                            @close="mostrarBusquedaJefe = false"
                            :codigo="empleado.codigoJefe",
                            :tipo="'jefe'"
                          )
                  .control.flex-1
                    p DNI
                    input.input(
                      type="text",
                      v-model="empleado.dni"
                      :disabled="isLoading"
                    )
                  .control.flex-1
                    p Régimen
                    .select
                      select(v-model='empleado.regimen',:disabled="isLoading")
                        option(value="general") General
                        option(value="pyme") PYME
                .flex.position-relative.fd-c-datos
                  .control.flex-1.title-singular
                    p Fecha Nacimiento
                    .input-container
                      input.input(
                        type="date",
                        v-model="empleado.fechaNacimiento"
                        :disabled="isLoading"
                      )
                  .control.flex-1.title-singular(v-if="empresa !== 'raymisa'")
                    p Area
                    .input-container
                      input.input(
                        type="text",
                        v-model="empleado.idArea"
                        :disabled="isLoading"
                        readonly
                        @click="mostrarBusquedaArea = true"
                        v-if="!empleado.idArea"
                      )
                      .item.fdc.flex-1(v-else)
                        span {{ nombreArea | capitalize }}
                        span.name {{ nombreGerencia }}
                      span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaArea = true")
                        i.fa.fa-search
                      .erase-data(@click="borrarArea")
                        .icon
                          .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaArea"
                        )
                        lookup-area(
                          @selected="seleccionarArea"
                          @close="mostrarBusquedaArea = false"
                        )
                  .control.flex.title-singular.fdc.space-evenly
                    button.button.is-small.is-primary.m-5.select-doc(@click="openModalSeleccionarDocumentosFirmar")
                      span.icon.is-small
                        i.fa.fa-upload.is-small
                      span
                        span Seleccionar
                        br
                        span documentos
                        br
                        span por firmar
                  // FOTO DE PERFIL
              .foto-perfil-container
                p Foto de perfil

                .foto-preview
                  img(
                    v-if="fotoPreview"
                    :src="fotoPreview"
                    alt="Foto de perfil"
                  )

                  i.fa.fa-user-circle(v-else)

                input(
                  ref="inputFoto"
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  @change="seleccionarFoto"
                  style="display:none"
                )

                button.button.is-small.is-primary(
                  type="button"
                  @click="$refs.inputFoto.click()"
                  :disabled="isLoading"
                )
                  span.icon
                    i.fa.fa-camera
                  span &nbsp; Seleccionar foto

                button.button.is-small.is-danger(
                  v-if="fotoPreview"
                  type="button"
                  @click="eliminarFoto"
                )
                  span.icon
                    i.fa.fa-trash
            .flex.position-relative.fd-c-datos
              .control.flex.title-singular.fdc.space-evenly
                button.button.is-small.is-success.has-text-bold.m-5(@click="verLibroDeVacaciones")
                  span.icon.is-small
                    i.fa.fa-eye.is-small
                  span Ver libro de vacaciones
        section.padding-top-10
          .title
            | Contrato
          .body
            .flex.fd-c-contrato
              .control.flex-1
                p Fecha Ingreso
                input.input(
                  type="date",
                  v-model="empleado.fechaIngreso",
                  :disabled="codigoEmpleadoInterno > 0"
                )
              .control(key="tiene-contrato-indefinido")
                p ¿Contrato indefinido?
                .opciones
                  .opcion(
                    @click="empleado.contratoIndeterminado = 1"
                    :class="{'active': empleado.contratoIndeterminado === 1}"
                  )
                    span Si
                  .opcion(
                    @click="empleado.contratoIndeterminado = 0"
                    :class="{'active': empleado.contratoIndeterminado === 0}"
                  )
                    span No
              .control.flex-1(v-if="empleado.contratoIndeterminado === 0")
                p Fecha fin contrato
                input.input(
                  type="date",
                  v-model="empleado.fechaFinContrato",
                  :disabled="isLoading"
                )
        section.padding-top-10
          .title
            | Pensión
          .body
            .flex.fd-c-pension
              .control.flex-1
                p Tipo Pension
                input.input(
                  type="text",
                  v-model="empleado.tipoPension"
                  :disabled="isLoading"
                )
              .control.flex-1
                p AFP Codigo
                input.input(
                  type="text",
                  v-model="empleado.afpCodigo"
                  :disabled="isLoading"
                )
              .control.flex-1
                p AFP Nombre
                input.input(
                  type="text",
                  v-model="empleado.afpNombre"
                  :disabled="isLoading"
                )
        section.padding-top-10
          .title
            | Sueldo
          .body
            .flex.fd-c-sueldo
              .control.flex-1
                p Cuenta Sueldo
                input.input(
                  type="text",
                  v-model="empleado.sueldoCuenta"
                  :disabled="isLoading"
                )
              .control.flex-1
                p Codigo Banco Sueldo
                input.input(
                  type="text",
                  v-model="empleado.sueldoCodigoBanco"
                  :disabled="isLoading"
                )
              .control.flex-1
                p Banco Sueldo
                input.input(
                  type="text",
                  v-model="empleado.sueldoNombreBanco"
                  :disabled="isLoading"
                )
              .control(key="moneda-sueldo")
                p Moneda sueldo
                .opciones
                  .opcion(
                    @click="empleado.sueldoMoneda = 'soles'"
                    :class="{'active': empleado.sueldoMoneda === 'soles'}"
                  )
                    span S/
                  .opcion(
                    @click="empleado.sueldoMoneda = 'dolares'"
                    :class="{'active': empleado.sueldoMoneda === 'dolares'}"
                  )
                    span USD
              //- .control.flex-1
                p Moneda Sueldo
                input.input(
                  type="text",
                  v-model="empleado.sueldoMoneda"
                )
        section.padding-top-10
          .title
            | CTS
          .body
            .flex.fd-c-cts
              .control.flex-1
                p CTS cuenta
                input.input(
                  type="text",
                  v-model="empleado.ctsCuenta"
                  :disabled="isLoading"
                )
              .control.flex-1
                p Codigo Banco CTS
                input.input(
                  type="text",
                  v-model="empleado.ctsCodigoBanco"
                  :disabled="isLoading"
                )
              .control.flex-1
                p Banco CTS
                input.input(
                  type="text",
                  v-model="empleado.ctsNombreBanco"
                  :disabled="isLoading"
                )
              .control(key="moneda-cts")
                p Moneda CTS
                .opciones
                  .opcion(
                    @click="empleado.ctsMoneda = 'soles'"
                    :class="{'active': empleado.ctsMoneda === 'soles'}"
                  )
                    span S/
                  .opcion(
                    @click="empleado.ctsMoneda = 'dolares'"
                    :class="{'active': empleado.ctsMoneda === 'dolares'}"
                  )
                    span USD
      footer.modal-card-foot.flex.padding-5
        a.card-footer-item.is-success(v-if="codigoEmpleadoInterno === 0 ||(empleado.codigo > 0 && empleado.activo === 1)" @click="guardarEmpleado")
          span(v-if="isLoading") Guardando...
          span(v-else) Guardar
        a.card-footer-item( @click="close")
          strong Cancelar
    transition(name='fade', v-if="mostrarObservaciones")
      .modal(:class="{'is-active' : mostrarObservaciones}")
        .modal-background
        .card(v-on-clickaway="closeModalObservaciones")
          header.card-header
            p.card-header-title
              span Observaciones encontradas
            a.card-header-icon
              span.icon
                button.delete(@click="closeModalObservaciones")
          .card-content.card-content-observaciones-max-height
            .content.has-text-left
              div(v-if="observaciones.length > 0" v-for="o in observaciones")
                strong {{o}}
          footer.card-footer
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            @click="closeModalObservaciones",
            :disabled="isLoading"
            ) Cancelar
</template>
<script>
import { apiGet, apiPost, notify, apiUploadWithParams, apiDelete }  from '../util/general'
import { mixin as clickaway }       from 'vue-clickaway';
import mt                           from 'moment'
import SeleccionarDocumentosFirmar from './Component_Seleccionar_Documentos_Firmar';
import ComponentListaLibrosVacaciones from './Component_Lista_Libros_Vacaciones'
import LookupSmallEmpleado          from '@/components/Component_Lookup_Small_Empleado'
import ComponentLookupCargo         from './Component_Lookup_Cargo';
import Area                         from './lookups/Area'
export default {
  name: 'component-empleado-editar',
  props : {
    codigoEmpleado : {
      type : Number,
      default : 0
    }
  },
  mixins: [ clickaway ],
  data () {
    return {
      empresa               : process.env.EMPRESA,
      mostrarModalSeleccionarDocumentosFirmar: false,
      mostrarModalListaLibrosVacaciones: false,
      codigoEmpleadoInterno : this.codigoEmpleado,
      isLoading             : false,
      mostrarBusquedaJefe   : false,
      mostrarBusquedaCargo  : false,
      mostrarObservaciones  : false,
      mostrarBusquedaArea   : false,
      observaciones         : [],
      nombreArea            : '',
      nombreGerencia        : '',
      empleado : {
        codigo                : 0,
        password              : '',
        usuario               : '',
        perfilVacaciones      : '',
        nombre                : '',
        fechaNacimiento       : '',
        idArea                : '',
        cargo                 : '',
        email                 : '',
        codigoJefe            : '',
        fechaIngreso          : '',
        dni                   : '',
        contratoIndeterminado : 0,
        fechaFinContrato      : '',
        tipoPension           : '',
        afpCodigo             : '',
        afpNombre             : '',
        sueldoCuenta          : '',
        sueldoCodigoBanco     : '',
        sueldoNombreBanco     : '',
        sueldoMoneda          : 'soles',
        ctsCuenta             : '',
        ctsCodigoBanco        : '',
        ctsNombreBanco        : '',
        ctsMoneda             : 'soles'
      },
      fotoPerfil: null,
      fotoPreview: null
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    showSidebarMobile () {
      return this.$store.getters.showSidebarMobile
    }
  },
  components : {
    LookupSmallEmpleado,
    'lookup-cargo':ComponentLookupCargo,
    'lookup-area':Area,
    SeleccionarDocumentosFirmar,
    'component-lista-libros-vacaciones': ComponentListaLibrosVacaciones
  },
  created () {
    var vm = this
    if (vm.codigoEmpleadoInterno > 0) {
      vm.fetch()
    }
  },
  methods : {
    closeModalListaLibrosVacaciones () {
      this.mostrarModalListaLibrosVacaciones = false
    },
    verLibroDeVacaciones () {
      var vm = this
      vm.mostrarModalListaLibrosVacaciones = true
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        codigo: vm.codigoEmpleadoInterno
      }
      apiGet(vm, '/empleado/obtener/one', obj, function (data) {
        vm.empleado                  = data.empleado
        vm.empleado.fechaIngreso     = data.empleado.fechaIngresoString
        vm.empleado.fechaFinContrato = data.empleado.fechaFinContratoString
        vm.empleado.fechaNacimiento  = data.empleado.fechaNacimientoString
        vm.codigoEmpleadoInterno     = data.empleado.codigo
        vm.fotoPreview               = data.empleado.pathFoto
        if (vm.empresa !== 'raymisa') {
          vm.nombreArea                = data.empleado.nombreArea
          vm.nombreGerencia            = data.empleado.nombreGerencia
        } else {
          vm.empleado.idArea                   = ''
        }
        if (!data.empleado.regimen || data.empleado.regimen === null) {
          vm.empleado.regimen = 'general'
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardarEmpleado (openAsignarDoc = false) {
      var vm = this
      vm.observaciones = []
      if (vm.isLoading) return

      vm.isLoading = true
      if (vm.empleado.contratoIndeterminado === 0) {
        if (vm.empleado.fechaFinContrato !== '') {
          vm.empleado.fechaFinContrato = mt(vm.empleado.fechaFinContrato, 'YYYY-MM-DD').format('DD/MM/YYYY')
        }
      }

      if (vm.empleado.fechaIngreso !== '') {
        vm.empleado.fechaIngreso = mt(vm.empleado.fechaIngreso, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }

      var obj = {
        empleado : vm.empleado
      }
      apiPost(vm, '/empleado/', obj, function (data) {
        vm.codigoEmpleadoInterno = data.codigo
        setTimeout(() => {
          notify(vm, 'success', 'Éxito', 'Guardado correctamente')
          vm.fetch()
        }, 2000);
        if (openAsignarDoc === true) {
          vm.openModalSeleccionarDocumentosFirmar()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.isLoading = false
        if (vm.empleado.contratoIndeterminado === 0) {
          if (vm.empleado.fechaFinContrato !== '') {
            vm.empleado.fechaFinContrato = mt(vm.empleado.fechaFinContrato, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }
        }
        if (vm.empleado.fechaIngreso !== '') {
          vm.empleado.fechaIngreso = mt(vm.empleado.fechaIngreso, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }
        if (error.observaciones.length > 0) {
          vm.mostrarObservaciones = true
          vm.observaciones = error.observaciones
        }
      }, function () {
      })
    },
    seleccionarJefe (o) {
      var vm = this
      vm.empleado.codigoJefe = o.codigo
    },
    seleccionarCargo (o) {
      var vm = this
      vm.empleado.cargo = o.cargo
    },
    seleccionarArea (o) {
      var vm = this
      vm.empleado.idArea = o.idArea
      vm.empleado.nombreArea = o.nombreArea
      vm.empleado.nombreGerencia = o.nombreGerencia
      vm.nombreArea = o.nombreArea
      vm.nombreGerencia = o.nombreGerencia
    },
    borrarArea () {
      var vm = this
      vm.empleado.idArea = ''
      vm.empleado.nombreArea = ''
      vm.empleado.nombreGerencia = ''
      vm.nombreArea = ''
      vm.nombreGerencia = ''
    },
    closeModalObservaciones () {
      this.mostrarObservaciones = false
    },
    closeModalSeleccionarDocumentosFirmar () {
      this.mostrarModalSeleccionarDocumentosFirmar = false
    },
    openModalSeleccionarDocumentosFirmar () {
      var vm = this
      if (vm.codigoEmpleadoInterno > 0) {
        this.mostrarModalSeleccionarDocumentosFirmar = true
        return
      }
      vm.guardarEmpleado(true)
    },
    close () {
      this.$emit('close')
    },
    seleccionarFoto (event) {
      var vm = this
      const file = event.target.files[0];

      if (!file) {
        return;
      }

      const tiposPermitidos = [
        'image/jpeg',
        'image/png',
        'image/webp'
      ];

      if (!tiposPermitidos.includes(file.type)) {
        this.$toast.error('Solo se permiten imágenes JPG, PNG o WEBP');
        return;
      }

      const maxSize = 5 * 1024 * 1024;

      if (file.size > maxSize) {
        this.$toast.error('La imagen no debe superar los 5 MB');
        return;
      }

      this.fotoPerfil = file;

      if (this.fotoPreview &&
          this.fotoPreview.startsWith('blob:')) {
        URL.revokeObjectURL(this.fotoPreview);
      }
      vm.uploadFile(file, function (err, response) {
        if (err) {
          notify(vm, 'error', 'Error', err.message)
        } else {
          vm.empleado.foto = response.file.ruta
          vm.fotoPreview = URL.createObjectURL(file);
        }
      })
    },
    uploadFile (file, callback) {
      var vm  = this
      var url = '/upload'
      var fd  = new FormData()
      fd.append('file', file)
      var params = {
        carpeta: 'fotoPerfil',
        usuario: localStorage.getItem('usuario')
      }
      apiUploadWithParams(vm, url, fd, params,
        function (res) {
          callback && callback(null, res)
        },
        function (err) {
          callback && callback(err)
        }
      )
    },
    eliminarFoto () {
      var vm = this
      if (this.fotoPreview &&  this.fotoPreview.startsWith('blob:')) {
        URL.revokeObjectURL(this.fotoPreview);
      }

      this.fotoPerfil = null;
      this.fotoPreview = null;

      if (this.$refs.inputFoto) {
        this.$refs.inputFoto.value = '';
      }
      if (+vm.codigoEmpleadoInterno > 0) {
        var obj = {
          codigo : vm.codigoEmpleadoInterno
        }
        apiDelete(vm, '/personal/fotoPerfil', obj, function (data) {
          notify(vm, 'success', 'Éxito', data.message)
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.select-doc
  padding-bottom: 25px !important
  padding-top: 25px !important

.img
  padding-bottom: 10px
  img
    max-width 100%
    width auto
    height 130px
    border-radius 5px
.space-evenly
  justify-content space-evenly
.eliminar-firma
  padding: 13px 0px;
.item
  background: #fff;
  border-radius: 3px;
  border: 1px solid #d6dadc;
  border-bottom-color: #c4c9cc;
  -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
  box-shadow: 0 1px 6px rgba(0,0,0,.15);
  display flex
  padding 10px
  margin-bottom 5px
  cursor pointer
  transition all .2s ease
.name
  font-size 12px
  color #666
.w-942
  width 90% !important
.contenedor-datos
  .close
    float right
    cursor pointer
    i
      font-size 16px

  .title
    font-size 20px
    span
      font-weight bold
      text-transform uppercase
    .little
      font-size 14px

section
  .control
    margin 5px
  .title
    text-align left
    border-bottom 2px solid #565cde
    padding-bottom 10px
    font-size 20px !important
.padding-top-87
  padding-top: 87px;
.flex
  display: flex
.padding-10
  padding: 10px
.opciones
  display flex
  .opcion
    cursor pointer
    width 50px
    margin 5px
    text-align center
    border 1px solid #565cde
    &.active
      background-color #565cde
      color white
.padding-top-10
  padding-top: 10px;
.input-container
  display flex
  align-items center
  .input
    flex 1
    width 100px
  .erase-data
    cursor pointer
    margin-left 5px
.position-relative
  position relative
.pop-over
  background: #fff;
  border-radius: 3px;
  border: 1px solid #d6dadc;
  border-bottom-color: #c4c9cc;
  -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
  box-shadow: 0 1px 6px rgba(0,0,0,.15);
  position: absolute;
  min-width: 100px
  width: 100%;
  z-index: 70;
  top 0
.title-singular
  text-align left
  user-select: none
.uppercase
  text-transform uppercase
.boton-container
    button
      margin-left 5px
.padding-15
  padding: 15px
.width-70
  width: 70%;
.padding-5
  padding: 5px;
.card-content-max
  max-height: calc(100vh - 300px);
  overflow: auto;
.info-box-button
  border-radius 0
  border        0px


@media (max-width 675px)
  .fd-c-sueldo
    flex-direction column

@media (max-width 660px)
  .fd-c-cts
    flex-direction column

@media (max-width 615px)
  .fd-c-datos
    flex-direction column

@media (max-width 560px)
  .fd-c-contrato
    flex-direction column

@media (max-width 500px)
  .fd-c-pension
    flex-direction column
.datos-empleado-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.foto-perfil-container {
  width: 150px;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.foto-preview {
  width: 120px;
  height: 120px;
  border: 1px solid #ddd;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.foto-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.foto-preview i {
  font-size: 90px;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// Component_Empleado_Editar.vue?9954b646